import { PersonaEditor } from '@/components/admin/personas/persona-editor';
import { Link, createFileRoute } from '@tanstack/react-router';

/**
 * Le persona neuf - the empty editor (refonte modulaire §10, H14; maquette
 * `NouveauPersona`).
 *
 * ## It calls almost nothing
 *
 * « Avant ce premier enregistrement il n'existe ni entité ni brouillon
 * serveur : la saisie ne vit que dans la page » (§6, and §4 for every object).
 * So this route has no entity query, no autosave and nothing to reload - which
 * is also why it is a route of its own rather than `/admin/personas/$personaId`
 * with a sentinel id: an editor that had to answer « is this id real » on every
 * write would carry the branch in nine places instead of in one
 * `detail === null`.
 *
 * « Almost », because the editor still reads the SCALE: H14 opens a new persona
 * anonymous, on the FIRST cran and without a redefinition, and the first cran is
 * a row of the settings tab. `PersonaEditor` waits for it before mounting the
 * layer, for the reason its own header gives.
 *
 * The static segment wins over the dynamic one in TanStack Router, so
 * `/admin/personas/nouveau` can never be read as a persona called « nouveau ».
 *
 * `onView` and `onCloseView` are no-ops here, and that is honest rather than
 * lazy: there is no history to open a version from, so the gesture cannot be
 * reached - the history panel renders its « Aucune version » sentence instead
 * of a single line.
 */

export const Route = createFileRoute('/admin/personas/nouveau')({
  component: NouveauPersonaPage,
});

function NouveauPersonaPage() {
  return (
    <div className="space-y-6">
      <p className="text-gray-600 text-sm">
        <Link to="/admin/personas" className="text-bleu-nuit underline underline-offset-2">
          Personas
        </Link>
        <span className="mx-2">›</span>
        Nouveau persona
      </p>
      <PersonaEditor
        detail={null}
        viewing={null}
        onView={() => undefined}
        onCloseView={() => undefined}
        onReload={() => undefined}
      />
    </div>
  );
}
